import script from "./RecommendedNews.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedNews.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedNews.vue?vue&type=style&index=0&id=7c5c202b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5c202b"]])

export default __exports__